import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { TableCell, TableRow, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import PagingTable from "components/items/paging-table";
import { USER_IMPORT_LOG_PAGE_SIZE_OPTIONS,
  isUserImportLogLoading,
  getErrorMessage,
  getUserImportLog,
  getPageInfo } from "app/auth/store/reducers/userImportLog.reducer";
import { fetchBulkUserImportLog } from "app/main/users/actions/users.actions";
import { formatUtcDate } from "helpers/format-date-time";
import withPermissions from "permissions/withPermissions";
import { getBulkUserLoadAllowEditing } from "app/auth/store/reducers/system-configuration";

const UserImportLogTable = ({ orgUnit }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(isUserImportLogLoading);
  const error = useSelector(getErrorMessage);
  const importLogs = useSelector(getUserImportLog);
  const pageInfo = useSelector(getPageInfo);
  const userEditingAllowed = useSelector(getBulkUserLoadAllowEditing);

  const orgUnitId = orgUnit?.id;

  useEffect(() => {
    dispatch(fetchBulkUserImportLog(orgUnitId, 1, pageInfo.pageSize));
  }, [dispatch, orgUnitId, pageInfo.pageSize]);

  const loadImportLogResults = (pageNumber, pageSize) => dispatch(fetchBulkUserImportLog(orgUnitId, pageNumber, pageSize));
  const onChangeRowsPerPage = pageSize => loadImportLogResults(1, pageSize);
  const onChangePage = pageNumber => loadImportLogResults(pageNumber + 1, pageInfo.pageSize);

  const handleRowClick = async importLog => {
    history.push({
      pathname: `/admin/users/importLog/${importLog.id}`,
      state: {
        fromUrl: "/admin/users/importLog",
        fileName: importLog.fileName,
        uploadedDateTime: importLog.uploadedDateTime,
      },
    });
  };

  const renderTableHeader = () => (
    <TableRow>
      <TableCell>Uploaded By</TableCell>
      <TableCell>Upload Date/Time</TableCell>
      <TableCell>File Name</TableCell>
      {userEditingAllowed && <TableCell>New Users Only</TableCell>}
      <TableCell>New Users</TableCell>
      {userEditingAllowed && <TableCell>Updated Users</TableCell>}
      <TableCell>Status</TableCell>
    </TableRow>
  );

  const renderTableRow = importLog => (
    <TableRow
      hover
      key={`${importLog.uploadedByUsername}-${importLog.uploadedDateTime}`}
      onClick={() => handleRowClick(importLog)}
      style={{ cursor: "pointer" }}
    >
      <TableCell>{importLog.uploadedByUsername}</TableCell>
      <TableCell>{formatUtcDate(importLog.uploadedDateTime, "DD-MMM-YY HH:mm")}</TableCell>
      <TableCell>{importLog.fileName}</TableCell>
      {userEditingAllowed && <TableCell>{importLog.newUsersOnly ? "Yes" : "No"}</TableCell>}
      <TableCell>{importLog.newUsersCount}</TableCell>
      {userEditingAllowed && <TableCell>{importLog.updatedUsersCount}</TableCell>}
      <TableCell>
        {importLog.hasErrors ? (
          <Typography color="error">ERRORS</Typography>
        ) : (
          <Typography color="primary">SUCCESS</Typography>
        )}
      </TableCell>
    </TableRow>
  );

  return (
    <PagingTable
      loading={loading}
      error={error}
      data={importLogs}
      rowsPerPage={pageInfo.pageSize}
      columnSpan={userEditingAllowed ? 7 : 5}
      pageSizeOptions={USER_IMPORT_LOG_PAGE_SIZE_OPTIONS}
      page={pageInfo.pageNumber - 1}
      count={pageInfo.totalRecords}
      onChangeRowsPerPage={onChangeRowsPerPage}
      onChangePage={onChangePage}
      emptyMessage="No Import Log Found"
      tableHead={renderTableHeader}
      tableRow={item => renderTableRow(item)}
    />
  );
};

export default withPermissions("BulkUserImportLogView")(UserImportLogTable);
